import { motion, useReducedMotion } from 'framer-motion';
import Container from './ui/Container';
import { staggerChild, staggerParent } from './ui/Reveal';

function PageHeader({ title, description, children }) {
  const reduce = useReducedMotion();

  return (
    <section className="relative overflow-hidden bg-lavender pb-14 pt-14 sm:pb-20 sm:pt-20 lg:pb-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(245,244,251,0)_0%,#f5f4fb_100%)]"
      />
      <img
        src="/main_logo.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 -top-16 w-[320px] rotate-[-10deg] opacity-[0.12] sm:w-[460px] lg:-right-8 lg:-top-24 lg:w-[560px]"
      />
      <Container className="relative">
        <motion.div
          className="max-w-3xl"
          variants={staggerParent(0.12)}
          initial={reduce ? false : 'hidden'}
          animate="visible"
        >
          <motion.h1
            variants={staggerChild(0, -44)}
            className="text-balance text-[2.4rem] font-bold leading-[1.15] tracking-[-0.03em] sm:text-5xl lg:text-[3.6rem]"
          >
            {title}
          </motion.h1>
          {description ? (
            <motion.p
              variants={staggerChild(0, -44)}
              className="mt-6 max-w-[40rem] text-base leading-[1.8] text-ink-soft sm:text-lg"
            >
              {description}
            </motion.p>
          ) : null}
          {children ? (
            <motion.div variants={staggerChild(0, -44)} className="mt-8">
              {children}
            </motion.div>
          ) : null}
        </motion.div>
      </Container>
    </section>
  );
}

export default PageHeader;
